import React from 'react';
import Icon from '../../../components/AppIcon';

const DemoTypeCard = ({ type, isSelected, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={`w-full p-6 rounded-lg border-2 transition-all text-left ${
        isSelected
          ? 'border-primary bg-primary/5' :'border-border hover:border-primary/50 bg-card'
      }`}
    >
      <div className="flex items-start gap-4">
        <div
          className={`p-3 rounded-lg ${
            isSelected ? 'bg-primary text-white' : 'bg-muted text-foreground'
          }`}
        >
          <Icon name={type?.icon} size={24} />
        </div>
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-foreground mb-2">
            {type?.title}
          </h3>
          <p className="text-sm text-muted-foreground mb-3">
            {type?.description}
          </p>
          <div className="flex flex-wrap gap-2">
            {type?.features?.map((feature, index) => (
              <span
                key={index}
                className="inline-flex items-center gap-1 px-2 py-1 bg-muted rounded text-xs text-foreground"
              >
                <Icon name="Check" size={12} />
                {feature}
              </span>
            ))}
          </div>
        </div>
      </div>
    </button>
  );
};

export default DemoTypeCard;